/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublishQuestionsDto } from '../../models/publish-questions-dto';

export interface WorkerControllerPublishQuestions$Params {
  jobUuid: string;
      body: PublishQuestionsDto
}

export function workerControllerPublishQuestions(http: HttpClient, rootUrl: string, params: WorkerControllerPublishQuestions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, workerControllerPublishQuestions.PATH, 'post');
  if (params) {
    rb.path('jobUuid', params.jobUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

workerControllerPublishQuestions.PATH = '/worker/jobs/{jobUuid}/questions';
